"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_PERCENT = 85;
var isDevelopment = ['production', 'test'].indexOf(process.env.NODE_ENV) === -1;

var warn = function warn() {
  if (isDevelopment) {
    var _console;

    (_console = console).warn.apply(_console, arguments);
  }
};
/* eslint-disable react/no-unused-prop-types */


var Ticker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Ticker, _React$Component);

  function Ticker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Ticker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Ticker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", _this.getInitialState(_this.props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "increment", function () {
      var percent = _this.state.percent;
      percent += (Math.random() + 1 - Math.random()) * 3; // eslint-disable-line

      percent = percent < _this.state.maxPercent ? percent : _this.state.maxPercent;

      _this.setState({
        percent: percent
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "interval", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleProps", function (props) {
      var autoIncrement = props.autoIncrement,
          percent = props.percent,
          intervalTime = props.intervalTime;

      if (autoIncrement && percent >= 0 && percent < 99) {
        _this.interval = setInterval(_this.increment, intervalTime);
      }

      if (percent >= 100) {
        _this.setState({
          percent: 99.9
        }, function () {
          _this.timeout = setTimeout(function () {
            _this.setState({
              percent: -1
            }, function () {
              return _this.props.updateProgress(-1);
            });
          }, 400);
        });
      } else {
        _this.setState({
          percent: percent
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "timeout", void 0);

    return _this;
  }

  _createClass(Ticker, [{
    key: "getInitialState",
    value: function getInitialState(props) {
      var maxPercent = props.maxPercent;

      if (typeof maxPercent !== 'number' || maxPercent < 1 || maxPercent > 100) {
        warn('fallback to default maxPercent');
        maxPercent = MAX_PERCENT;
      }

      return {
        maxPercent: maxPercent,
        percent: this.props.percent
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleProps(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.interval) {
        // stop progress when new props come in.
        clearInterval(this.interval);
        this.interval = undefined;
      }

      if (this.timeout) {
        // clear timeout when new props come in.
        clearTimeout(this.timeout);
        this.timeout = undefined;
      } // start progress with updated props.


      this.handleProps(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // cleaning up interval and timeout.
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = undefined;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.renderProgress(this.state.percent);
    }
  }]);

  return Ticker;
}(_react.default.Component);

_defineProperty(Ticker, "defaultProps", {
  percent: -1,
  autoIncrement: true,
  intervalTime: 450,
  maxPercent: MAX_PERCENT,
  renderProgress: function renderProgress() {
    return null;
  }
});

var _default = Ticker;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-progress/es/Ticker.js
// module id = 1061
// module chunks = 0